(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ShiftTypeController', ShiftTypeController);

    ShiftTypeController.$inject = ['GenericEntityDatatableService', 'CoreService', 'ShiftType', '$uibModal',
        'ConfirmationService', '$q'];

    function ShiftTypeController(GenericEntityDatatableService, CoreService, ShiftType, $uibModal,
                                 ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Shift Type',
            newButtonTitle: 'New Shift Type',
            entityClassHumanized: 'Shift Type',
            entityStateName: 'shift-type',
            service: ShiftType,
            serviceMethod: 'byCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Shift Type',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/shift-type/update/shift-type-dialog.html',
                controller: 'ShiftTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/shift-type/update/shift-type-dialog.html',
                controller: 'ShiftTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['ShiftType', function (ShiftType) {
                        return ShiftType.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Shift Type').result.then(function () {
                    ShiftType.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
